var map = {
	"./anemo-robotics_white.png": 2379,
	"./azraq_white.png": 4144,
	"./bridges_white.png": 433,
	"./canarygreen_white.png": 182,
	"./coasts_white.png": 4286,
	"./coral-sea-foundation_white.png": 2574,
	"./future-swell_white.png": 7454,
	"./oceanwise_white.png": 9089,
	"./t-loop_white.png": 2662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6382;